module.exports = {"540521100":"扎塘镇","540521101":"桑耶镇","540521200":"扎其乡","540521201":"阿扎乡","540521202":"吉汝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540521.json
// module id = 2724
// module chunks = 0